import type { TPermissionKey } from "@agt/contract";
import type { LucideIcon } from "lucide-react";
import {
  BookOpen,
  Building2,
  Contact,
  CreditCard,
  FileText,
  LayoutDashboard,
  Receipt,
  Settings2,
  Shield,
  Users,
  Wallet,
  ArrowLeftRight,
  ListTree,
} from "lucide-react";
export type V2Destination = {
  path: string;
  label: string;
  group: string;
  icon: LucideIcon;
  permission?: TPermissionKey;
  masterOnly?: boolean;
};
export const v2Destinations: V2Destination[] = [
  {
    path: "dashboard",
    label: "Overview",
    group: "Workspace",
    icon: LayoutDashboard,
  },
  {
    path: "financial/transaction",
    label: "Transactions",
    group: "Financial",
    icon: ArrowLeftRight,
    permission: "transaction:read",
  },
  {
    path: "financial/bill",
    label: "Bills",
    group: "Financial",
    icon: Receipt,
    permission: "bill:read",
  },
  {
    path: "financial/account-receivable",
    label: "Receivables",
    group: "Financial",
    icon: Wallet,
    permission: "account_receivable:read",
  },
  {
    path: "financial/account-payable",
    label: "Payables",
    group: "Financial",
    icon: CreditCard,
    permission: "account_payable:read",
  },
  {
    path: "financial/invoice",
    label: "Invoices",
    group: "Financial",
    icon: FileText,
    permission: "invoice:read",
  },
  {
    path: "financial/journal",
    label: "Journal",
    group: "Financial",
    icon: BookOpen,
    permission: "journal:read",
  },
  {
    path: "financial/petty-cash",
    label: "Petty cash",
    group: "Financial",
    icon: Wallet,
    masterOnly: true,
  },
  {
    path: "master-data/client",
    label: "Clients",
    group: "Master data",
    icon: Building2,
    permission: "client_company:read",
  },
  {
    path: "master-data/vendor",
    label: "Vendors",
    group: "Master data",
    icon: Building2,
    permission: "vendor:read",
  },
  {
    path: "master-data/contact",
    label: "Contacts",
    group: "Master data",
    icon: Contact,
    permission: "contact:read",
  },
  {
    path: "master-data/customer",
    label: "Customers",
    group: "Master data",
    icon: Users,
    permission: "customer:read",
  },
  {
    path: "master-data/user",
    label: "Users",
    group: "Master data",
    icon: Users,
    permission: "user:read",
  },
  {
    path: "master-data/account",
    label: "Chart of accounts",
    group: "Master data",
    icon: ListTree,
    permission: "account:read",
  },
  {
    path: "settings/general",
    label: "General",
    group: "Settings",
    icon: Settings2,
    permission: "settings:read",
  },
  {
    path: "settings/payment-methods",
    label: "Payment methods",
    group: "Settings",
    icon: CreditCard,
    permission: "payment_method:read",
  },
  {
    path: "settings/roles",
    label: "Roles & permissions",
    group: "Settings",
    icon: Shield,
    permission: "role_permission:read",
  },
];
